package com.wintermar.inspection.feature.presentation.inspection.answer.modal_state

import com.wintermar.inspection.core.ui.component.location.util.LocationModel

data class ModalLocationState(
    val show: Boolean = false,
    val questionId: String = "",
    val name: String = "",
    val data: LocationModel? = null
)
